import * as allIcons from '@progress/kendo-svg-icons';
import {SVGIcon}     from '@progress/kendo-svg-icons';
import {Injectable}  from '@angular/core';

/**
 * Agriport service which allows receiving kendo svgIcon instances through a singleton instance
 */
@Injectable({providedIn: 'root'})
export class ApKendoIconService {
  private static icons = allIcons;
  // When using Object.keys() or iterating over the object, 'default' appear because of how JavaScript treats module imports when import * as syntax is used.
  private static iconNames = Object.keys(allIcons).filter((key) => key !== 'default');

  /**
   * Gets an instance of kendo's SVGIcon with the given name
   * List of kendo SVG icons: https://www.telerik.com/kendo-angular-ui/components/icons/svgicon/svgicon-list
   * @param iconName the svgIcon name
   */
  public static Get(iconName: string): SVGIcon | undefined {
    if (!iconName || ApKendoIconService.iconNames.indexOf(iconName) === -1) {
      return undefined;
    }
    return ApKendoIconService.icons[iconName];
  }

  public Get(iconName: string): SVGIcon | undefined {
    return ApKendoIconService.Get(iconName);
  }
}
